/* eslint-disable react/display-name */
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { AboveMobile } from '@mssgme/ui';
import AvatarEdit from '../Editing/AvatarEdit';
import BrandingEdit from '../Editing/BrandingEdit';
import CoverEdit from '../Editing/CoverEdit';
import CategoryEdit from '../Editing/CategoryEdit';
import DescriptionEdit from '../Editing/DescriptionEdit';
import Domain from '../Editing/Domain';
import { PageSettingsMenu, PageEditMenu, PageTrackingMenu } from '../Editing/PageMenu';
import SeoEdit from '../Editing/SeoEdit';
import TitleEdit from '../Editing/TitleEdit';
import UrlEdit from '../Editing/UrlEdit';
import WebsiteEdit from '../Editing/WebsiteEdit';
import WidgetCard from '../WidgetCard';
import PageMain from '../Editing/PageMain';
import PageShare from '../Editing/PageShare';
import PageMessengers from '../Editing/PageMessengers';
import MessengerEdit from '../Editing/MessengerEdit';
import PageLinks from '../Editing/PageLinks';
import LinkEdit from '../Editing/LinkEdit';
import PageAnalytics from '../Editing/PageAnalytics';
import PixelEdit from '../Editing/PixelEdit';
import ReviewsEdit from '../Editing/ReviewsEdit';
import {
    ProductsMain,
    PageProducts,
    PageProductsCollections,
    ProductCollectionEdit,
    ProductEdit,
} from '../Editing/Products';
import { CardPreview } from '../../UI';

import styles from './CardPage.scss';

const ROUTES = [
    { path: '/p/share', component: PageShare },
    { path: '/p/edit', component: PageEditMenu, exact: true },
    { path: '/p/edit/avatar', component: AvatarEdit, exact: true },
    { path: '/p/edit/cover', component: CoverEdit, exact: true },
    { path: '/p/edit/title', component: TitleEdit, exact: true },
    { path: '/p/edit/description', component: DescriptionEdit, exact: true },
    { path: '/p/edit/website', component: WebsiteEdit, exact: true },
    { path: '/p/edit/category', component: CategoryEdit, exact: true },
    { path: '/p/edit/messengers/:platform', component: MessengerEdit, exact: true },
    { path: '/p/edit/messengers', component: PageMessengers, exact: true },
    { path: '/p/edit/links', component: PageLinks, exact: true },
    { path: '/p/edit/links/new', component: LinkEdit, exact: true },
    { path: '/p/edit/links/:linkId', component: LinkEdit, exact: true },
    { path: '/p/settings', component: PageSettingsMenu, exact: true },
    { path: '/p/settings/url', component: UrlEdit, exact: true },
    { path: '/p/settings/url/domain/edit', component: Domain, exact: true },
    { path: '/p/settings/branding', component: BrandingEdit, exact: true },
    { path: '/p/settings/tracking', component: PageTrackingMenu, exact: true },
    { path: '/p/settings/tracking/:platform', component: PixelEdit, exact: true },
    { path: '/p/settings/seo', component: SeoEdit, exact: true },
    { path: '/p/reviews', component: ReviewsEdit, exact: true },
    // { path: '/p/widget', component: WidgetEdit, exact: true },
    { path: '/p/analytics', component: PageAnalytics, exact: true },
    { path: '/p/products/collections/new', component: ProductCollectionEdit, exact: true },
    {
        path: '/p/products/collections/edit/:id',
        render: () => <ProductCollectionEdit />,
        exact: true,
    },
    { path: '/p/products/all', component: PageProducts, exact: true },
    {
        path: '/p/products/collections/:id',
        render: () => <PageProducts />,
        exact: true,
    },
    { path: '/p/products/collections', component: PageProductsCollections, exact: true },
    { path: '/p/products', component: ProductsMain, exact: true },
    {
        path: '/p/products/new/:collectionId',
        render: () => <ProductEdit />,
        exact: true,
    },
    { path: '/p/products/new', component: ProductEdit, exact: true },
    {
        path: '/p/products/:productId',
        render: () => <ProductEdit />,
        exact: true,
    },
    { path: '/p', component: PageMain, exact: true },
];

export function CardPage() {
    return (
        <div className={styles.root}>
            <div className={styles.sidebar}>
                <Switch>
                    {ROUTES.map((props, index) => (
                        <Route key={index} {...props} />
                    ))}
                </Switch>
            </div>
            <AboveMobile>
                <div className={styles.container}>
                    <Switch>
                        <Route path="/p/share/widget" component={WidgetCard} />
                        <Route path="/p" component={CardPreview} />
                    </Switch>
                </div>
            </AboveMobile>
        </div>
    );
}
